import InputNumber from './_input-number';

export default InputNumber;
